import { Pipe, PipeTransform } from '@angular/core';
import { PluckPipe } from './pluck.pipe';

@Pipe({
  name: 'joinProperty',
  standalone: true,
})
export class JoinPropertyPipe implements PipeTransform {

  transform(value: any[], key: string, separator: string) {
    const flattenArray = new PluckPipe().transform(value, key);
    if (!flattenArray) {
      return null;
    }

    return flattenArray.join(separator);
  }

}
